import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["aria-checked", "aria-disabled", "aria-readonly"]
const _hoisted_3 = {
  key: 0,
  class: "rc__label"
}
const _hoisted_4 = ["id", "checked", "disabled", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["rc", {
      'rc--checked': _ctx.modelValue,
      'rc--indeterminate': _ctx.indeterminate,
      'rc--disabled': _ctx.disabled,
      'rc--error': _ctx.error,
    }]),
    style: _normalizeStyle(_ctx.styles),
    for: _ctx.id || undefined
  }, [
    _createElementVNode("span", {
      class: "rc__control",
      role: "checkbox",
      "aria-checked": _ctx.ariaChecked,
      "aria-disabled": _ctx.disabled ? 'true' : 'false',
      "aria-readonly": _ctx.readonly ? 'true' : 'false',
      tabindex: "0",
      onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('focus'))),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('blur'))),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [...(_cache[5] || (_cache[5] = [
      _createElementVNode("span", { class: "rc__ring" }, null, -1),
      _createElementVNode("span", { class: "rc__fill" }, null, -1),
      _createElementVNode("span", { class: "rc__mark" }, null, -1)
    ]))], 40, _hoisted_2),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.t(_ctx.label)), 1))
      : _createCommentVNode("", true),
    (_ctx.id)
      ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          id: _ctx.id,
          type: "checkbox",
          class: "rc__native",
          checked: _ctx.modelValue,
          disabled: _ctx.disabled,
          readonly: _ctx.readonly,
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, null, 40, _hoisted_4))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}